import React, { useState } from "react"
import { OptionButton } from "./option-button"
import { CustomInput } from "./custom-input"

const PADDING = {
  none: 0,
  normal: 18,
  large: 36
}

function allPaddingsEqual(properties, value) {
  return (
    properties.paddingTop === value &&
    properties.paddingRight === value &&
    properties.paddingBottom === value &&
    properties.paddingLeft === value
  )
}

function getPadding(properties) {
  if (allPaddingsEqual(properties, PADDING.none)) return "none"
  if (allPaddingsEqual(properties, PADDING.normal)) return "normal"
  if (allPaddingsEqual(properties, PADDING.large)) return "large"
  return "custom"
}

export function Padding({ properties, update }) {
  const padding = getPadding(properties)
  const [showCustom, setShowCustom] = useState(padding === "custom")

  function handlePaddingClick(size) {
    setShowCustom(false)
    update({
      paddingTop: PADDING[size],
      paddingRight: PADDING[size],
      paddingBottom: PADDING[size],
      paddingLeft: PADDING[size]
    })
  }

  return (
    <div>
      <div className="font-semibold text-gray-700 mb-1">Padding</div>
      <div className="flex border rounded mb-2">
        <div className="p-1 flex items-center justify-center flex-grow border-r">
          <OptionButton
            active={padding === "none" && !showCustom}
            onClick={() => handlePaddingClick("none")}
          >
            None
          </OptionButton>
          <OptionButton
            active={padding === "normal" && !showCustom}
            onClick={() => handlePaddingClick("normal")}
          >
            Normal
          </OptionButton>
          <OptionButton
            active={padding === "large" && !showCustom}
            onClick={() => handlePaddingClick("large")}
          >
            Large
          </OptionButton>
        </div>
        <div className="p-1 flex items-center justify-center">
          <OptionButton
            active={padding === "custom" || showCustom}
            onClick={() => setShowCustom(true)}
          >
            Custom
          </OptionButton>
        </div>
      </div>

      {showCustom && (
        <div className="grid grid-cols-2 gap-2">
          <CustomInput
            label="Top"
            value={properties.paddingTop || properties.horizontalPadding}
            onChange={value => update({ paddingTop: value })}
          />

          <CustomInput
            label="Right"
            value={properties.paddingRight || properties.verticalPadding}
            onChange={value => update({ paddingRight: value })}
          />

          <CustomInput
            label="Bottom"
            value={properties.paddingBottom || properties.horizontalPadding}
            onChange={value => update({ paddingBottom: value })}
          />

          <CustomInput
            label="Left"
            value={properties.paddingLeft || properties.verticalPadding}
            onChange={value => update({ paddingLeft: value })}
          />
        </div>
      )}
    </div>
  )
}
